import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPointer"><Path d="M11.25 9.25004H15.75C17.9591 9.25004 19.75 11.0409 19.75 13.25V13.8292C19.75 17.7895 16.5395 21 12.5792 21C9.91687 21 7.47366 19.525 6.23368 17.169L3.25 11.5L4.00061 10.5617C4.69063 9.69921 5.94921 9.55937 6.81174 10.2494L7.75 11V4.5C7.75 3.5335 8.5335 2.75 9.5 2.75C10.4665 2.75 11.25 3.5335 11.25 4.5V9.25004Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPointer;
